/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Titles_UsersInputs */

const en_settings_titles_users = /** @type {(inputs: Settings_Titles_UsersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Associated users`)
};

/**
* | output |
* | --- |
* | "Associated users" |
*
* @param {Settings_Titles_UsersInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_titles_users = /** @type {((inputs?: Settings_Titles_UsersInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Titles_UsersInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_titles_users(inputs)
});